var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/error-monitoring/sentry";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"78"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* @flow */

import { CaptureConsole, ExtraErrorData } from "@sentry/integrations";

import initSentry from "./sentry.shared.config"

initSentry({
    integrations: [
        new CaptureConsole({
            levels: ["warn", "error"],
        }),
        new ExtraErrorData(),
    ],
});
